export const ANALYSES_LPU_ONLINE_ORDER_CHIP_LABEL = 'Онлайн-заказ'

export const ANALYSES_LPU_DISCOUNT_CHIP_LABEL = 'Со скидкой'
